import React, { useState } from "react";
import "./Careers.css";
import PopupForm from "./PopupForm.js"; // Import the Popup Form

const CareersPage = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const openPositions = [
    {
      title: "Data Analyst",
      location: "Mumbai, India",
      type: "Full-Time",
      description: "Analyze business data and generate reports.",
    },
    {
      title: "AI/ML Engineer",
      location: "Remote",
      type: "Full-Time",
      description: "Build and deploy machine learning models.",
    },
    {
      title: "Software Developer",
      location: "Bangalore, India",
      type: "Full-Time",
      description: "Develop and maintain our web applications.",
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="hero-careers">
        <div className="hero-content">
          <h1>Careers</h1>
        </div>
      </section>


{/* Why Join Us? Section (Paragraph & Image) */}
<section className="why-join">
        <div className="why-join-content">
          <div className="text">
            <h2>Join Our Mission</h2>
            <p>
              At Data Bolta Hai, we believe in **empowering our team** with cutting-edge tools and technologies.
              Our **collaborative environment** ensures every employee has the opportunity to **grow, learn, and innovate**.
              We provide a **flexible work culture**, competitive benefits, and **continuous learning programs** to help
              you reach your full potential.
            </p>
            <button className="cta-button" onClick={() => setIsPopupOpen(true)}>
            Connect Now!
          </button>
          </div>
          <div className="image">
          <img src="/perks-image.jpg" alt="Perks of Joining" />
          </div>
        </div>
      </section>

      {/* Perks & Benefits */}
      <section className="perks-section">
        <h2>Why Join Data Bolta Hai?</h2>
        <div className="perks-grid">
          <div className="perk-card">🚀 Growth Opportunities</div>
          <div className="perk-card">🏡 Work from Home Flexibility</div>
          <div className="perk-card">💰 Competitive Salaries</div>
          <div className="perk-card">📚 Learning & Development</div>
          <div className="perk-card">🎉 Fun Work Culture</div>
          <div className="perk-card">🏥 Health Benefits</div>
        </div>
      </section>

      {/* Open Positions */}
      {/* <section className="open-positions">
        <h2>Open Positions</h2>
        <div className="positions-grid">
          {openPositions.map((position, index) => (
            <div key={index} className="position-card">
              <h3>{position.title}</h3>
              <p><strong>Location:</strong> {position.location}</p>
              <p><strong>Type:</strong> {position.type}</p>
              <p>{position.description}</p>
              <button className="apply-button">Apply Now</button>
            </div>
          ))}
        </div>
      </section> */}

      {/* Popup Form Component */}
            <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
};

export default CareersPage;


// import React, { useState } from "react";
// import "./Careers.css";
// import PopupForm from "./PopupForm.js";
// import { Dropbox } from "dropbox";

// const CareersPage = () => {
//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [uploadStatus, setUploadStatus] = useState("");

//   const openPositions = [
//     {
//       title: "Data Analyst",
//       location: "Mumbai, India",
//       type: "Full-Time",
//       description: "Analyze business data and generate reports.",
//     },
//     {
//       title: "AI/ML Engineer",
//       location: "Remote",
//       type: "Full-Time",
//       description: "Build and deploy machine learning models.",
//     },
//     {
//       title: "Software Developer",
//       location: "Bangalore, India",
//       type: "Full-Time",
//       description: "Develop and maintain our web applications.",
//     },
//   ];

//   const handleFileChange = (e) => {
//     setSelectedFile(e.target.files[0]);
//   };

//   const handleUpload = async () => {
//     if (!selectedFile) {
//       setUploadStatus("Please select a file to upload.");
//       return;
//     }

//     const dbx = new Dropbox({ accessToken: "YOUR_DROPBOX_ACCESS_TOKEN" });

//     try {
//       await dbx.filesUpload({
//         path: `/resumes/${selectedFile.name}`,
//         contents: selectedFile,
//       });
//       setUploadStatus("Resume uploaded successfully!");
//       setSelectedFile(null);
//     } catch (error) {
//       console.error("Upload Error:", error);
//       setUploadStatus("Upload failed. Please try again.");
//     }
//   };

//   return (
//     <div>
//       {/* Hero Section */}
//       <section className="hero-careers">
//         <div className="hero-content">
//           <h1>Careers</h1>
//         </div>
//       </section>

//       {/* Why Join Us Section */}
//       <section className="why-join">
//         <div className="why-join-content">
//           <div className="text">
//             <h2>Join Our Mission</h2>
//             <p>
//               At Data Bolta Hai, we believe in <strong>empowering our team</strong> with cutting-edge tools and technologies.
//               Our <strong>collaborative environment</strong> ensures every employee has the opportunity to <strong>grow, learn, and innovate</strong>.
//               We provide a <strong>flexible work culture</strong>, competitive benefits, and <strong>continuous learning programs</strong> to help
//               you reach your full potential.
//             </p>
//             <button className="cta-button" onClick={() => setIsPopupOpen(true)}>
//               Connect Now!
//             </button>
//           </div>
//           <div className="image">
//             <img src="/perks-image.jpg" alt="Perks of Joining" />
//           </div>
//         </div>
//       </section>

//       {/* Perks Section */}
//       <section className="perks-section">
//         <h2>Why Join Data Bolta Hai?</h2>
//         <div className="perks-grid">
//           <div className="perk-card">🚀 Growth Opportunities</div>
//           <div className="perk-card">🏡 Work from Home Flexibility</div>
//           <div className="perk-card">💰 Competitive Salaries</div>
//           <div className="perk-card">📚 Learning & Development</div>
//           <div className="perk-card">🎉 Fun Work Culture</div>
//           <div className="perk-card">🏥 Health Benefits</div>
//         </div>
//       </section>

//       {/* Upload Resume Section */}
//       <section className="upload-resume">
//         <h2>Upload Your Resume</h2>
//         <p>We'd love to hear from you. Upload your resume to be considered for upcoming roles.</p>
//         <input type="file" accept=".pdf,.doc,.docx" onChange={handleFileChange} />
//         <button className="upload-button" onClick={handleUpload}>Upload Resume</button>
//         {uploadStatus && <p className="upload-status">{uploadStatus}</p>}
//       </section>

//       {/* Popup Form */}
//       <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
//     </div>
//   );
// };

// export default CareersPage;
